import { debug } from "../LoginDbg.js";
import { Auth } from "firebase/auth";
import { AuthProviderIdentifier } from "../AuthProviderIdentifier.js";
import { ActualDataTuple, LoginError, LoginErrorCodes, ThirdPartyCientAuthData } from "../data/LoginData.js";
import { LoginProvider } from "./LoginProvider.js";
import { FirebaseWrapper } from "./FirebaseWrapper.js";
import { DetectedWebView, detectWebView } from "@ciaopeople/cp-shatsu/ClientDetection";
const INTERNAL_PROVIDER_ID = AuthProviderIdentifier.APPLE;
const DEFAULT_SCOPES: string[] = ['email', 'name'];



class AppleLogin implements LoginProvider {


    private useScopes: string[];
    private detectedWebview: DetectedWebView;

    constructor(public readonly firebaseWrapper: FirebaseWrapper, 
        scopes: string[]) {
        
        this.useScopes = scopes?scopes:DEFAULT_SCOPES;

        this.detectedWebview = detectWebView();
    }

    preloadAction(): Promise<void> {
        return this.sdkInit().then();
    }

    eventuallyHandleRevoke(hint: string, isDeleteRequest: boolean): Promise<boolean> {
        if(isDeleteRequest) {
            debug.write("Doing sign out on deleteRequest");
            return this.sdkInit().then(auth => {
                if(auth.currentUser) {
                    return auth.signOut().then(_ => true);
                }
                else return false;
            });
        }
        else {
            debug.write("Nothing to delete ... simple logout");
            return Promise.resolve(true);
        }
    }

    getSessionDataForAutologin(): Promise<ThirdPartyCientAuthData> {
        return Promise.reject(new LoginError(LoginErrorCodes.NO_SESSION_FOUND, "Not Unsupported"));
    }

    promptLogin(): Promise<ThirdPartyCientAuthData> {
        return this.sdkInit().then(auth => {
            if(!this.detectedWebview.native_app &&
                this.detectedWebview?.device?.phone &&
                this.detectedWebview?.platform?.ios
            ) {
                console.log("[APPLE] Redirect");
                
                return this.firebaseWrapper.appleSignInWithRedirect(auth,this.useScopes);
            }
            else {
                console.log("[APPLE] PopUp");
                return this.firebaseWrapper.appleSignInWithPopup(auth, this.useScopes);
            }
        }).then(
            result => {
                return this.firebaseWrapper.credentialFromResult(result).then(
                    cred => {
                        return {
                            result: result,
                            credential: cred
                        };
                    }
                );
            }
        ).then( ({ result, credential }) => {
            const user = result.user;
            
            const accessToken = credential.accessToken;
            const idToken = credential.idToken;
            debug.write("FBASE USER", user);
            debug.write("FBASE CREDENTIAL", credential);
            debug.write("FBASE IDTOKEN", idToken);
            debug.write("FBASE ACCESS_TOKEN", accessToken);
            //const intermediate = new IntermediateDataTuple(AuthProviderIdentifier.FIREBASE, accessToken, idToken);
            const actual = new ActualDataTuple(INTERNAL_PROVIDER_ID, accessToken, idToken);
            return new ThirdPartyCientAuthData(null, actual);
                
        }).catch( error => {
            return Promise.reject(new LoginError(0, "There was an error on apple login via firebase", error));
        });
    }

    oneTapLogin(): Promise<ThirdPartyCientAuthData> {
        return Promise.reject(new LoginError(0, "Unsupported function in Apple"));
    }

    sdkInit(): Promise<Auth> {
        return this.firebaseWrapper.auth();
    }

    niceName: string = "AppleID";
    supportsAutoLogin: boolean = false;
    useOwnLoginPrompt: boolean = true;
    providerId: AuthProviderIdentifier = INTERNAL_PROVIDER_ID;
    supportsOneTap: boolean = false;

}




export { AppleLogin };